import { activeGateway, useAppSelector } from 'app/store';

export const useGateway = () => {
    return useAppSelector(activeGateway);
};
 